import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('LadProvidersDA', LadProvidersDA);

    LadProvidersDA.$inject = ['logger', 'CONF', 'Restangular', 'LadProvider'];

    /**
     * Class utilitaire servant à la manipulation de dom
     */

    /* @ngInject */
    function LadProvidersDA(logger, CONF, Restangular, LadProvider) {
        var baseUrlProxy = CONF.proxyEpdf + CONF.apiBaseUrl + '/v1/lad-provider';

        var exports = {
            getAll: getAll
        };

        return exports;

        ////////////////
        function getAll() {
            return Restangular.all(baseUrlProxy)
                .getList()
                .then(function(ladProviderList) {
                    return _.map(ladProviderList, function(ladProvider) {
                        return new LadProvider(ladProvider);
                    });
                });
        }
    }
})();
